import Card from "./Card";
import _ from "lodash";
import styles from "./ContentTab.module.scss";
import cx from "classnames";

const View = ({ data }: any) => {
  return (
    <>
      <div
        className={cx("", styles.content, {
          [styles.onlyOne]: data.length === 1,
        })}
      >
        {_.map(data, (item, index) => {
          // Use slug as primary key (should be unique and stable)
          // If slug is missing, create a stable key from title + index to avoid React reconciliation issues
          const key = item?.slug || (item?.title ? `${item.title}-${index}` : `offer-${index}`);
          return <Card key={key} {...item} />;
        })}
      </div>
      {/* <div className={styles.button}>
        <Button label="load more" />
      </div> */}
    </>
  );
};
export default View;
